import isEmail from 'validator/lib/isEmail'
import matches from 'validator/lib/matches'
import isLength from 'validator/lib/isLength'
import isURL from 'validator/lib/isURL'
import isHexColor from 'validator/lib/isHexColor'
import isMobilePhone from 'validator/lib/isMobilePhone'
import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import { ValidationError } from 'react-vld'
import moment from 'moment'

const validDomainChars = /^[a-z0-9-]+$/i
const validDomainName = /^(?!-)(?!.*--)[A-Za-z0-9-]+[^-]$/i

export const validateRequiredString = (value, message) => {
  if (isEmpty(value.trim())) {
    throw new ValidationError(message)
  }
}

export const validateDomain = (value, message) => {
  if (value !== '' && (!matches(value, validDomainName)
    || !matches(value, validDomainChars) || !isLength(value, { min: 5, max: 50 }))) {
    throw new ValidationError(message)
  }
}

export const validateEmail = (value, message) => {
  if (value !== '' && !isEmail(value)) {
    throw new ValidationError(message)
  }
}

export const validateURL = (value, message) => {
  if (value !== '' && !isURL(value)) {
    throw new ValidationError(message)
  }
}

export const validateMobilePhone = (value, message) => {
  if (value !== '' && !isMobilePhone(value, 'any')) {
    throw new ValidationError(message)
  }
}

export const validateRange = (value, min, max, message) => {
  const v = parseFloat(value)
  if (value !== '' && (Number.isNaN(v) || v < min || v > max)) {
    throw new ValidationError(message)
  }
}

export const validateEqualStrings = (str1, str2, message) => {
  if (str1 !== str2) {
    throw new ValidationError(message)
  }
}

export const validateMinLength = (value, minLength, message) => {
  if (value !== '' && value.length < minLength) {
    throw new ValidationError(message)
  }
}

export const validateMaxLength = (value, maxLength, message) => {
  if (value !== '' && value.length > maxLength) {
    throw new ValidationError(message)
  }
}

export const validateRequiredObject = (value, message) => {
  if (!isObject(value) || isEmpty(value)) {
    throw new ValidationError(message)
  }
}

export const validateRequiredArray = (value, message) => {
  if (!isArray(value) || isEmpty(value)) {
    throw new ValidationError(message)
  }
}

export const validateNotNil = (value, message) => {
  if (isNil(value)) {
    throw new ValidationError(message)
  }
}

export const validateNumber = (value, message) => {
  const valueFloat = parseFloat(value)
  if (value !== '' && Number.isNaN(valueFloat)) {
    throw new ValidationError(message)
  }
}

export const validateDate = (date, message) => {
  if (date && !moment(date).isValid()) {
    throw new ValidationError(message)
  }
}

export const validateMinDate = (date, minDate, message) => {
  if (date && moment(date).isBefore(minDate)) {
    throw new ValidationError(message)
  }
}

export const validateMaxDate = (date, maxDate, message) => {
  if (date && moment(date).isAfter(maxDate)) {
    throw new ValidationError(message)
  }
}

export const validateRequiredDate = (date, message) => {
  if (!date || !moment(date).isValid()) {
    throw new ValidationError(message)
  }
}

export const validateHexColor = (value, message) => {
  if (value !== '' && (!isHexColor(value) || value[0] !== '#')) {
    throw new ValidationError(message)
  }
}
